import { IconButton, Tooltip } from "@mui/material";

const CustomEditUploadIcon = ({ ...props }) => {
  const color = props?.color || "#1976d2";
  const size = props?.size || "22px";
  const fileSrc = "/public/icon/action-edit-upload.svg";

  return (
    <Tooltip title={props?.label || "Set terms"} placement="left" arrow>
      <IconButton {...props}>
        <div
          style={{
            width: size,
            height: size,
            // marginLeft: "10px",
            display: "inline-block",
            verticalAlign: "middle",
            backgroundColor: color,
            maskImage: "url(" + fileSrc + ")",
            maskSize: "contain",
            WebkitMaskImage: "url(" + fileSrc + ")",
            WebkitMaskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default CustomEditUploadIcon;
